module.exports = __webpack_public_path__ + "assets/img/voice.c02bd468.svg";